import { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { db } from "../firebase/config";

export default function useDeportistas() {
  const [deportistas, setDeportistas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(
    collection(db, "deportistas"),
    orderBy("orden", "asc")
    );

  const unsub = onSnapshot(
    q,
    (snap) => {
      setDeportistas(
        snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      );
      setLoading(false);
    },
    (error) => {
      console.error("Error cargando deportistas:", error);
      setLoading(false); // 🔥 CLAVE
    }
  );

  return () => unsub();
}, []);

  return { deportistas, loading };
}
